export const EmptyComponent = () => null;
